<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <div class="personal-details">

                <div class="header-block">
                    <div class="header-title">
                        <app-breadcrumb></app-breadcrumb>
                    </div>
                    <div class="add-block">
                        <div class="search">
                            <form autocomplete="off">
                                <input type="text" placeholder="search" (keyup.enter)="getVendorByWildSearch(0,10)"
                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="searchKey">
                            </form>
                            <i class="bi bi-search" (click)="getVendorByWildSearch(0,10)"></i>
                        </div>

                        <button data-toggle="modal" title="Add" data-target="#addModal" *ngIf="actionControls.isAdd"><i
                                class="bi bi-plus-lg"></i> {{ 'generic.add' | translate }}</button>
                        <div class="filter-icon">
                            <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                        </div>

                    </div>
                </div>

                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 25%;">{{ 'vendor-master.name' | translate }}</th>
                            <th style="width: 25%;">{{ 'vendor-master.description' | translate }}</th>
                            <th style="width: 20%;">{{ 'vendor-master.code' | translate }}</th>
                            <th style="width: 20%;">{{ 'vendor-master.latestStatus' | translate }}</th>
                            <th style="width: 10%;text-align: center;padding: 0;" class="">{{ 'generic.action' |
                                translate }}</th>
                        </tr>
                    </thead>
                </table>
                <div *ngIf="!isLoading">
                    <div class="data-view" *ngFor="let list of vendorList | paginate : {
                      itemsPerPage: tableSize,
                      currentPage: pageNumber,
                      totalItems: totalRecords
                      }  ;let i = index">

                        <p style="width: 25%;">{{list.name}}</p>
                        <p style="width: 25%;">{{list.description}}</p>
                        <p style="width: 20%;">{{list.code}}</p>
                        <p style="width: 20%;">{{list.latestStatus}}</p>
                        <p class="action-buttons" style="width: 10%;padding-left: 25px;">
                            <i *ngIf="actionControls.isView" (click)="getVendorById(list.vendorMasterId)"
                                data-toggle="modal" data-target="#view" class="bi bi-eye-fill"></i>
                            <i *ngIf="actionControls.isDelete" title="Delete" class="bi bi-trash3"
                                (click)="deleteIdSelect(list.id,list)" data-toggle="modal"
                                data-target="#deleteModal"></i>

                        </p>
                    </div>
                </div>


                <div class="loader" *ngIf="isLoading">
                    <div class="spinner"></div>
                </div>

                <div class="loader" *ngIf="!isLoading && vendorList.length == 0">
                    <div class="no-data">
                        <img src="assets/no-data-6.png" alt="">
                        <p>no data found</p>
                    </div>

                </div>

                <div class="paginator">
                    <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize"
                        [totalRecords]="totalRecords" [showFirstLastIcon]="false" [showCurrentPageReport]="true"
                        currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
                </div>


            </div>

        </div>
    </div>
</div>


<div class="modal fade" id="view" tabindex="-1" data-backdrop="static" aria-labelledby="view" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{ 'vendor-master.headings.detail' | translate }}
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body" *ngFor="let data of sigleVendorData">
                <div class="row">
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>{{ 'vendor-master.name' | translate }}</label>
                            <p>{{data.name}}</p>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>{{ 'vendor-master.contactName' | translate }}</label>
                            <p>{{data.contactName}}</p>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>{{ 'vendor-master.contactPhone' | translate }}</label>
                            <p>{{data.contactPhone}}</p>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>{{ 'vendor-master.contactEmail' | translate }}</label>
                            <p>{{data.contactEmail}}</p>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>{{ 'vendor-master.code' | translate }}</label>
                            <p>{{data.code}}</p>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>{{ 'vendor-master.type' | translate }}</label>
                            <p>{{data.type}}</p>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-12"
                        *ngIf="data.image != null && data.image != undefined && data.image != ''">
                        <div class="form-group image-view">
                            <label>{{ 'vendor-master.image' | translate }} </label>
                            <img [src]="data.image" alt="" srcset="">
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-12 col-lg-12" *ngIf="data.documents.length != 0">
                        <label>{{ 'vendor-master.documents' | translate }} </label>
                        <div class="doc-image-view">
                            <div *ngFor="let doc of data.documents">
                                <div class="" *ngIf="doc.type == 'image/png' || doc.type == 'image/jpeg'">
                                    <img [src]="doc.url" alt="" srcset="">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-6 col-lg-6" *ngFor="let key of data.keyValueList">
                        <div class="form-group">
                            <label>{{key.key}}</label>
                            <p>{{key.value}}</p>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-12 col-lg-12">
                        <label>{{ 'vendor-master.address' | translate }}</label>
                        <div class="row addresse-block">
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label>{{ 'vendor-master.name' | translate }}</label>
                                    <p>{{data.geoAddress.name || " -- "}}</p>
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label>{{ 'vendor-master.phone1' | translate }}</label>
                                    <p>{{data.geoAddress.phone1 || " -- "}}</p>
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label>{{ 'vendor-master.email' | translate }}</label>
                                    <p>{{data.geoAddress.email || " -- "}}</p>
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label>{{ 'vendor-master.address' | translate }}</label>
                                    <p>{{data.geoAddress.address || " -- "}}</p>
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label>{{ 'vendor-master.landmark' | translate }}</label>
                                    <p>{{data.geoAddress.landmark || " -- "}}</p>
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label>{{ 'vendor-master.city' | translate }}</label>
                                    <p>{{data.geoAddress.city || " -- "}}</p>
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label>{{ 'vendor-master.town' | translate }}</label>
                                    <p>{{data.geoAddress.town || " -- "}}</p>
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label>{{ 'vendor-master.district' | translate }}</label>
                                    <p>{{data.geoAddress.district || " -- "}}</p>
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label>{{ 'vendor-master.postCode' | translate }}</label>
                                    <p>{{data.geoAddress.postCode || " -- "}}</p>
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label>{{ 'vendor-master.state' | translate }}</label>
                                    <p>{{data.geoAddress.state || " -- "}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <!-- <button type="button" *ngIf="data.latestStatus == 'APPLIED'" (click)="rejectVendor()" class="btn btn-danger reject">Reject</button> -->
                    <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">{{
                        'generic.cancel' | translate }}</button>
                    <!-- <button type="button" *ngIf="data.latestStatus == 'APPLIED'" (click)="approveVendor()" class="btn btn-primary">Approve</button> -->
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="addModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{ 'vendor-master.headings.add' | translate }}
                    <span data-dismiss="modal">
                        <i data-dismiss="modal" class="bi bi-x-lg"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div [formGroup]="vendorForm" class="row">
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>{{ 'vendor-master.name' | translate }}</label>
                            <input formControlName="name" type="text" class="form-control">
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>{{ 'vendor-master.contactName' | translate }}</label>
                            <input formControlName="contactName" type="text" class="form-control">
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>{{ 'vendor-master.contactPhone' | translate }}</label>
                            <input formControlName="contactPhone" type="text" class="form-control">
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>{{ 'vendor-master.contactEmail' | translate }}</label>
                            <input formControlName="contactEmail" type="text" class="form-control">
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>{{ 'vendor-master.code' | translate }}</label>
                            <input formControlName="code" type="text" class="form-control">
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>{{ 'vendor-master.type' | translate }}</label>
                            <input formControlName="type" type="text" class="form-control">
                        </div>
                    </div>


                    <div class="col-sm-12 col-md-6 col-lg-6" *ngFor="let key of keyValueList">
                        <div class="form-group">
                            <label>{{key.key}}</label>
                            <input *ngIf="key.boxType == 'Input'" class="form-control"
                                [ngModelOptions]="{standalone: true}" [(ngModel)]="key.value" type="text"
                                class="form-control">
                            <select *ngIf="key.boxType == 'Dropdown'" class="form-control" name="" id=""
                                [ngModelOptions]="{standalone: true}" [(ngModel)]="key.value">
                                <option [value]="possibleValue" *ngFor="let possibleValue of key.possibleValue">
                                    {{possibleValue}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-12 col-lg-12">
                        <!-- <label>Address</label> -->
                        <div class="row addresse-block">
                            <div class="col-md-12 col-lg-12">
                                <div class="address-block">
                                    <label style="text-align: center;">{{ 'vendor-master.address' | translate }}</label>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <div class="form-group">
                                    <label>{{ 'vendor-master.name' | translate }}</label>
                                    <input [(ngModel)]="geoAddress.name" [ngModelOptions]="{standalone: true}"
                                        type="text" class="form-control">
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <div class="form-group">
                                    <label>{{ 'vendor-master.phone1' | translate }}</label>
                                    <input [(ngModel)]="geoAddress.phone1" [ngModelOptions]="{standalone: true}"
                                        type="text" class="form-control">
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <div class="form-group">
                                    <label>{{ 'vendor-master.email' | translate }}</label>
                                    <input [(ngModel)]="geoAddress.email" [ngModelOptions]="{standalone: true}"
                                        type="text" class="form-control">
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <div class="form-group">
                                    <label>{{ 'vendor-master.address' | translate }}</label>
                                    <input [(ngModel)]="geoAddress.address" [ngModelOptions]="{standalone: true}"
                                        type="text" class="form-control">
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <div class="form-group">
                                    <label>{{ 'vendor-master.landmark' | translate }}</label>
                                    <input [(ngModel)]="geoAddress.landmark" [ngModelOptions]="{standalone: true}"
                                        type="text" class="form-control">
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <div class="form-group">
                                    <label>{{ 'vendor-master.city' | translate }}</label>
                                    <input [(ngModel)]="geoAddress.city" [ngModelOptions]="{standalone: true}"
                                        type="text" class="form-control">
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <div class="form-group">
                                    <label>{{ 'vendor-master.town' | translate }}</label>
                                    <input [(ngModel)]="geoAddress.town" [ngModelOptions]="{standalone: true}"
                                        type="text" class="form-control">
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <div class="form-group">
                                    <label>{{ 'vendor-master.district' | translate }}</label>
                                    <input [(ngModel)]="geoAddress.district" [ngModelOptions]="{standalone: true}"
                                        type="text" class="form-control">
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <div class="form-group">
                                    <label>{{ 'vendor-master.postCode' | translate }}</label>
                                    <input [(ngModel)]="geoAddress.postCode" [ngModelOptions]="{standalone: true}"
                                        type="text" class="form-control">
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <div class="form-group">
                                    <label>{{ 'vendor-master.state' | translate }}</label>
                                    <input [(ngModel)]="geoAddress.state" [ngModelOptions]="{standalone: true}"
                                        type="text" class="form-control">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-6 col-lg-6" style="margin-top: 15px;">
                        <div class="form-group image-b" *ngIf="vendorForm.controls['image'].value == ''">
                            <label>{{ 'vendor-master.image' | translate }} </label>
                            <button class="" (click)="imageButtonClick()">{{ 'generic.add' | translate }}</button>
                            <input type="file" id="imageInput" (change)="onChange($event)" accept="image/*"
                                [style.display]="'none'">
                        </div>
                        <div class="form-group image-view" *ngIf="vendorForm.controls['image'].value != ''">
                            <label>{{ 'vendor-master.image' | translate }} </label>
                            <img [src]="vendorForm.controls['image'].value" alt="" srcset="">
                            <button class="btn btn-secondary" (click)="imageRemove()">{{ 'generic.remove' | translate
                                }}</button>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-12 col-lg-12">
                        <div class="form-group image-b">
                            <label>{{ 'vendor-master.documents' | translate }} </label>
                            <button class="" (click)="docButtonClick()">{{ 'generic.add' | translate }}</button>
                            <input type="file" id="DocInput" (change)="onChangeDoc($event)" accept="image/*"
                                [style.display]="'none'">
                        </div>
                        <div *ngIf="documents.length != 0" class="doc-image-view">
                            <div *ngFor="let doc of documents">
                                <div class="" *ngIf="doc.type == 'image/png' || doc.type == 'image/jpeg'">
                                    <img [src]="doc.url" alt="" srcset="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeAdd" class="btn btn-secondary" data-dismiss="modal">{{
                        'generic.cancel' | translate }}</button>

                    <button type="button" (click)="addVendor()" class="btn btn-primary">{{ 'generic.submit' | translate
                        }}</button>
                </div>
            </div>
        </div>
    </div>
</div>




<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
                    <span data-dismiss="modal">
                        <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                            fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path
                                d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
                        </svg>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <p>{{ 'generic.deleteText' | translate }} <span class="delete-span">“{{recordName}}”</span>?</p>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton1" class="btn btn-secondary" data-dismiss="modal">{{
                        'generic.cancel' | translate }}</button>
                    <button type="button" (click)="deleleVendor()" class="btn btn-primary">{{ 'generic.delete' |
                        translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>